module.exports = __webpack_public_path__ + "static/media/partner-clinic.236ae722.svg";